import { render, staticRenderFns } from "./BuilderToolbar.vue?vue&type=template&id=1c8a09cd&scoped=true&"
var script = {}
import style0 from "./BuilderToolbar.vue?vue&type=style&index=0&id=1c8a09cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a09cd",
  null
  
)

export default component.exports